import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import WorkPageHeader from '../../components/work/WorkPageHeader';
import { Card } from 'antd';
import { ApartmentOutlined } from '@ant-design/icons';
import DepartmentsCard from '../../components/live-chat/DepartmentsCard';

const LiveChatDepartments = () => (
  <MainLayout>
    <div style={{ fontFamily: 'CustomFont' }}>
      <Card className="shadow-xl border-0 work-page-card" styles={{ body: { padding: 0 } }}>
        <WorkPageHeader title="بخش‌ها" subtitle="مدیریت بخش‌های پاسخ‌گویی" icon={ApartmentOutlined} />
        <div className="px-6 pb-6 work-page-body rounded-b-xl">
          <DepartmentsCard />
        </div>
      </Card>
    </div>
  </MainLayout>
);

export default LiveChatDepartments;
